import React, { useState } from 'react';
import { useTournament } from '../hooks/useTournament';
import ExcelImporter from './ExcelImporter';

const PlayerList = () => {
  const { players, addPlayer, removePlayer, renamePlayer } = useTournament();
  const [newPlayer, setNewPlayer] = useState('');
  const [editingIndex, setEditingIndex] = useState(null);
  const [editingValue, setEditingValue] = useState('');
  
  // Maximum number of players
  const MAX_PLAYERS = 100;
  
  // Calculate the percentage filled for the loading bar
  const percentageFilled = (players.length / MAX_PLAYERS) * 100;

  const handleAddPlayer = (e) => {
    e.preventDefault();
    if (newPlayer.trim()) {
      addPlayer(newPlayer.trim());
      setNewPlayer('');
    }
  };

  return (
    <div className="section">
      <div className="section-header">
        <h2>Spieler</h2>
        <span>{players.length}/{MAX_PLAYERS} Spieler</span>
      </div>
      <p className="info-text" style={{ marginTop: 0, marginBottom: '8px' }}>
        Hinweis: Spielernamen können später per <strong>Doppelklick</strong> direkt in der Liste geändert werden – auch nachdem das Turnier generiert wurde.
      </p>
      
      {/* Player loading bar */}
      <div className="player-loading-bar-container">
        <div 
          className="player-loading-bar" 
          style={{ width: `${percentageFilled}%` }}
        ></div>
      </div>

      <form onSubmit={handleAddPlayer}>
        <div className="input-group">
          <input
            type="text"
            value={newPlayer}
            onChange={(e) => setNewPlayer(e.target.value)}
            placeholder="Spielername eingeben"
            maxLength={30}
            disabled={players.length >= MAX_PLAYERS}
          />
          <button type="submit" disabled={players.length >= MAX_PLAYERS || !newPlayer.trim()}>
            Spieler hinzufügen
          </button>
        </div>
      </form>
      
      {/* Excel Import Component */}
      <ExcelImporter />

      {players.length === 0 ? (
        <p className="info-text">Bitte fügen Sie Spieler hinzu, um ein Turnier zu erstellen.</p>
      ) : (
        <div className="player-list">
          {players.map((player, index) => {
            const isEditing = editingIndex === index;
            return (
              <div key={index} className="player-item" onDoubleClick={() => {
                setEditingIndex(index);
                setEditingValue(player);
              }}>
                {isEditing ? (
                  <input
                    type="text"
                    value={editingValue}
                    autoFocus
                    maxLength={30}
                    onChange={(e) => setEditingValue(e.target.value)}
                    onBlur={() => {
                      const trimmed = editingValue.trim();
                      if (trimmed && trimmed !== player) {
                        renamePlayer(index, trimmed);
                      }
                      setEditingIndex(null);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        const trimmed = editingValue.trim();
                        if (trimmed && trimmed !== player) {
                          renamePlayer(index, trimmed);
                        }
                        setEditingIndex(null);
                      } else if (e.key === 'Escape') {
                        setEditingIndex(null);
                        setEditingValue('');
                      }
                    }}
                    style={{ flex: 1, marginRight: '8px' }}
                  />
                ) : (
                  <span title="Doppelklick zum Umbenennen">{player}</span>
                )}
                <button className="player-remove" onClick={() => removePlayer(index)}>
                  ✕
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default PlayerList;